import type { User } from '@klp/user';

export const ByggKundeAccess = (user?: User): boolean => {
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    return (user && user.isAdmin) || false;
};
